<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  nzWrapClassName="etikett-fullscreen-modal"
  nzWidth="100vw"
  [nzStyle]="{ top: '0', paddingBottom: '0', maxWidth: '100vw', margin: '0' }"
  [nzBodyStyle]="{ height: 'calc(100vh - 110px)', padding: '0', overflow: 'hidden' }"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <div class="etikett-dialog">
      <div class="etikett-dialog__form">
        <nz-spin [nzSpinning]="loading">
          <form nz-form [formGroup]="form" style="width: 100%" #formElement (ngSubmit)="submit()" id="labels-form">
            <nz-tabs>
              <nz-tab nzTitle="Text">
                <nz-form-item>
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="fullName">
                    <span>Name</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="14" [nzXs]="24">
                    <input nz-input id="fullName" formControlName="fullName" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="ean">
                    <span>EAN</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="14" [nzXs]="24">
                    <input nz-input id="ean" formControlName="ean" />
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="orderNumber">
                    <span>Bestellnummer</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="5" [nzXs]="24">
                    <input nz-input id="orderNumber" formControlName="orderNumber" />
                  </nz-form-control>
                  <nz-form-label [nzSm]="4" [nzXs]="24" nzFor="storageLocation">
                    <span>Lagerplatz</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="5" [nzXs]="24">
                    <input nz-input id="storageLocation" formControlName="storageLocation" />
                  </nz-form-control>
                </nz-form-item>

                <nz-divider></nz-divider>
                <nz-form-item>
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="articleNameFirstLine" nzRequired>
                    <span>Titel</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Dieses Feld wird benötigt.">
                    <input nz-input id="articleNameFirstLine" formControlName="articleNameFirstLine" />
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="articleNameSecondLine">
                    <span>Untertitel</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="14" [nzXs]="24">
                    <input nz-input id="articleNameSecondLine" formControlName="articleNameSecondLine" />
                  </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="featured">
                    <span>Auszeichnung</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="14" [nzXs]="24">
                    <input nz-input id="featured" formControlName="featured" />
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="descriptionFirstLine" nzRequired>
                    <span>Beschreibung</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Dieses Feld wird benötigt.">
                    <input nz-input id="descriptionFirstLine" formControlName="descriptionFirstLine" />
                  </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="descriptionSecondLine">
                    <span>Zusatzzeile</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="14" [nzXs]="24">
                    <input nz-input id="descriptionSecondLine" formControlName="descriptionSecondLine" />
                  </nz-form-control>
                </nz-form-item>

                @if (hasField('japan')) {
                  <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="additionalJapanText">
                      <span>Zusätzlicher Japan-Text</span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                      <input nz-input id="additionalJapanText" formControlName="additionalJapanText" />
                    </nz-form-control>
                  </nz-form-item>
                }

                @if (hasField('weight')) {
                  <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="weight" nzRequired>
                      <span>Gewicht</span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Dieses Feld wird benötigt.">
                      <nz-input-group nzCompact>
                        <input style="width: 70%;" nz-input id="weight" formControlName="weight" />
                        <nz-select
                          style="width: 30%;"
                          formControlName="unit"
                          (ngModelChange)="onChangeUnit()"
                          >
                          @for (unit of units; track unit) {
                            <nz-option
                              [nzLabel]="unit.label"
                              [nzValue]="unit.value"
                            ></nz-option>
                          }
                        </nz-select>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                }

                @if (hasField('charge')) {
                  <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="charge" nzRequired>
                      <span>Charge</span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Dieses Feld wird benötigt.">
                      <input nz-input id="charge" formControlName="charge" />
                    </nz-form-control>
                  </nz-form-item>
                }

                @if (hasField('mhd')) {
                  <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="mhd" nzRequired>
                      <span>MHD</span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Dieses Feld wird benötigt.">
                      <nz-date-picker
                        style="width: 100%;"
                        [nzFormat]="dateFormat"
                        id="mhd"
                        formControlName="mhd"
                        [nzDisabledDate]="disableDatesBeforeNow"
                      ></nz-date-picker>
                    </nz-form-control>
                  </nz-form-item>

                  <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24">
                      <span>Ohne MHD drucken</span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                      <label nz-checkbox formControlName="hideMhd"></label>
                    </nz-form-control>
                  </nz-form-item>
                }
              </nz-tab>

              <nz-tab nzTitle="Kennzeichnung">
                @if (hasField('ingredients')) {
                  <nz-form-item class="rich-text-form-item">
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="ingredients">
                      <span>Zutaten</span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Dieses Feld wird benötigt.">
                      <div class="angular-editor-custom-toolbar">
                        <nz-form-item style="margin-bottom: 0;">
                          <nz-form-label>
                            <span>Zeilenhöhe</span>
                          </nz-form-label>
                          <nz-form-control [nzSm]="6">
                            <span class="d-flex align-items-center">
                              <input nz-input type="number" formControlName="lineHeight" />
                              &nbsp;mm
                            </span>
                          </nz-form-control>
                        </nz-form-item>
                      </div>
                      <app-rich-text-editor
                        id="ingredients"
                        placeholder=""
                        [toolbarHiddenButtons]="toolbarHiddenButtons"
                        formControlName="ingredients"
                        height="80px"
                      ></app-rich-text-editor>
                    </nz-form-control>
                  </nz-form-item>
                }

                @if (hasField('ingredientsOnOtherLabel')) {
                  <nz-form-item>
                    <nz-form-control [nzSm]="6" [nzXs]="24"></nz-form-control>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                      <label nz-checkbox formControlName="hasIngredientsOnOtherLabel">Zutaten auf zweitem Etikett</label>
                    </nz-form-control>
                  </nz-form-item>
                }
                @if (hasField('expandedIngredients')) {
                  <nz-form-item>
                    <nz-form-control [nzSm]="6" [nzXs]="24"></nz-form-control>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                      <label nz-checkbox formControlName="hasExpandedIngredients">Mehr Platz für Zutaten</label>
                    </nz-form-control>
                  </nz-form-item>
                }
                @if (hasField('allergen')) {
                  <nz-form-item>
                    <nz-form-control [nzSm]="6" [nzXs]="24"></nz-form-control>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                      <label nz-checkbox formControlName="isAllergen">Enthält Allergene</label>
                    </nz-form-control>
                  </nz-form-item>
                }
                @if (hasField('nutrients')) {
                  <nz-form-item>
                    <nz-form-control [nzSm]="6" [nzXs]="24"></nz-form-control>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                      <label nz-checkbox formControlName="hasNutrients">Nährwerte drucken</label>
                    </nz-form-control>
                  </nz-form-item>
                }
                @if (hasField('bio')) {
                  <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="bioKind" nzRequired>
                      <span>BIO</span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                      <nz-select formControlName="bioKind" nzErrorTip="Dieses Feld wird benötigt.">
                        @for (type of bioKindsEnum | keyvalue; track type) {
                          <nz-option
                            [nzLabel]="bioKindsEnumTranslations[type.key]"
                            [nzValue]="type.value"
                          ></nz-option>
                        }
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                }
                @if (hasField('fairtrade')) {
                  <nz-form-item>
                    <nz-form-control [nzSm]="6" [nzXs]="24"></nz-form-control>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                      <label nz-checkbox formControlName="isFairtrade">Fairtrade-Siegel drucken</label>
                    </nz-form-control>
                  </nz-form-item>
                  @if (form.get('isFairtrade').value) {
                    <nz-form-item>
                      <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="fairtradeProduct">
                        <span>Fairtrade Produkt</span>
                      </nz-form-label>
                      <nz-form-control [nzSm]="14" [nzXs]="24">
                        <div class="d-flex align-items-center white-space-no-wrap">
                          <input nz-input id="fairtradeProduct" formControlName="fairtradeProduct" />
                        </div>
                      </nz-form-control>
                    </nz-form-item>
                  }
                }

                @if (hasField('nutrients') && form.controls['hasNutrients'].value) {
                  <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="nutritionalValues" >
                      <span>Nährwerte</span>
                    </nz-form-label>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-control [nzSm]="2" [nzXs]="0"></nz-form-control>
                    <nz-form-control [nzSm]="20" [nzXs]="24" nzErrorTip="Dieses Feld wird benötigt.">
                      <nz-table #editRowTable nzBordered [nzData]="nutrients" nzTableLayout="fixed" [nzFrontPagination]="false">
                        <thead>
                          <tr>
                            <th nzWidth="40%">Titel</th>
                            <th nzWidth="40%">Wert</th>
                            <th>Aktion</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (data of editRowTable.data; track data; let i = $index) {
                            <tr>
                              @if (!editNutrientsCache[i].edit) {
                                <td>{{ data.key }}</td>
                                <td>{{ data.value }}</td>
                                <td>
                                  <a (click)="startEdit(i)">
                                    <i
                                      nz-icon
                                      nzType="edit"
                                      nz-tooltip
                                      nzTooltipTitle="Bearbeiten"
                                    ></i>
                                  </a> &nbsp;&nbsp;
                                  <a (click)="remove(i)">
                                    <i
                                      nz-icon
                                      nzType="close"
                                      nz-tooltip
                                      nzTooltipTitle="Entfernen"
                                    ></i>
                                  </a>
                                </td>
                              } @else {
                                <td><input type="text" nz-input [(ngModel)]="editNutrientsCache[i].data.key" [ngModelOptions]="{standalone:true}"/></td>
                                <td><input type="text" nz-input [(ngModel)]="editNutrientsCache[i].data.value" [ngModelOptions]="{standalone:true}"/></td>
                                <td>
                                  <a
                                    (click)="saveEdit(i)"
                                    class="save-tab"
                                    >
                                    <i
                                      nz-icon
                                      nzType="save"
                                      nz-tooltip
                                      nzTooltipTitle="Speichern"
                                    ></i>
                                  </a> &nbsp;&nbsp;
                                  <a
                                    nz-popconfirm
                                    nzPopconfirmTitle="Sollen wir abbrechen?"
                                    (nzOnConfirm)="cancelEdit(i)"
                                    >
                                    <i
                                      nz-icon
                                      nzType="close"
                                      nz-tooltip
                                      nzTooltipTitle="Abbrechen"
                                    ></i>
                                  </a>
                                </td>
                              }
                            </tr>
                          }
                        </tbody>
                      </nz-table>
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                    <nz-form-control [nzOffset]="19" [nzXs]="4">
                      <button nz-button nzType="default" type="button" (click)="addEmptyNutrition()">
                        <i nz-icon nzType="plus"></i>
                        Hinzufügen
                      </button>
                    </nz-form-control>
                  </nz-form-item>
                }
              </nz-tab>

              <nz-tab nzTitle="Layout">
                <nz-form-item>
                  <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="labelType" nzRequired>
                    <span>Etikettenart</span>
                  </nz-form-label>
                  <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Dieses Feld wird benötigt.">
                    <nz-select formControlName="labelType">
                      @for (type of labelTypesEnum | keyvalue; track type) {
                        <nz-option
                          [nzLabel]="labelTypesEnumTranslations[type.key]"
                          [nzValue]="type.value"
                        ></nz-option>
                      }
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>

                @if (hasField('color')) {
                  <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="labelColor" nzRequired>
                      <span>Etikettenfarbe</span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Dieses Feld wird benötigt.">
                      <nz-select formControlName="labelColor" [nzCustomTemplate]="selectedLabelColorTemplate">
                        @for (type of labelColorsEnum | keyvalue; track type) {
                          <nz-option
                            nzCustomContent
                            [nzLabel]="type.key"
                            [nzValue]="type.value"
                            >
                            <span class="color-option">
                              <span class="color-square color-square--{{ type.key }}"></span>
                              {{ labelColorsTranslations[type.key] }}
                            </span>
                          </nz-option>
                        }
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                }

                @if (hasField('fontSize')) {
                  <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24">
                      <span>Schriftgröße</span>
                    </nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24">
                      <nz-radio-group
                        [ngModel]="schriftgroesse"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onSchriftgroesseChange($event)"
                      >
                        <label nz-radio nzValue="normal">normal</label>
                        <label nz-radio nzValue="klein">klein</label>
                        <label nz-radio nzValue="sehr-klein">sehr klein</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                }
              </nz-tab>
            </nz-tabs>
          </form>
        </nz-spin>
      </div>
      <div class="etikett-dialog__preview">
        <app-label-preview-host [preview]="preview" [loading]="previewLoading"></app-label-preview-host>
      </div>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" [disabled]="loading" (click)="copyFromOtherVariant()">
      <i nz-icon nzType="copy"></i>
      von anderem Etikett übernehmen
    </button>
    <button nz-button nzType="default" [disabled]="loading" (click)="regenerateLabel()" >
      <i nz-icon nzType="printer"></i>
      Etikett neu generieren
    </button>
    @if (variant?.labelKey) {
      <button nz-button nzType="default" [disabled]="loading" appOpenPdf [key]="variant?.labelKey">
        <i nz-icon nzType="printer"></i>
        Drucken
      </button>
    }
    @if (variant?.ingredientLabelKey) {
      <button nz-button nzType="default" [disabled]="loading" appOpenPdf [key]="variant?.ingredientLabelKey" [rounded]="true">
        <i nz-icon nzType="printer"></i>
        Gerundet Drucken
      </button>
    }
    <button nz-button nzType="default" (click)="handleCancel()">Schließen</button>
    <button nz-button nzType="primary" type="submit" form="labels-form" [nzLoading]="loading">Speichern</button>
  </ng-template>
</nz-modal>

<ng-template #selectedLabelColorTemplate let-selected>
  <span class="color-option">
    <span class="color-square color-square--{{ selected.nzLabel }}"></span>
    {{ labelColorsTranslations[selected.nzLabel] }}
  </span>
</ng-template>

<ng-template #copyFromOtherVariantRef>
  <nz-select
    style="width: 100%;"
    nzPlaceHolder="Variante auswählen"
    nzShowSearch
    nzServerSearch
    [(ngModel)]="articleToCopy"
    (nzOnSearch)="onArticleForCopySearch($event)"
    >
    @for (o of articleList; track o) {
      @if (!isArticlesLoading) {
        <nz-option [nzValue]="o" [nzLabel]="o.value"></nz-option>
      }
    }
    @if (isArticlesLoading) {
      <nz-option nzDisabled nzCustomContent>
        <i nz-icon nzType="loading" class="loading-icon"></i> Daten laden...
      </nz-option>
    }
  </nz-select>
</ng-template>
